// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-user-pop.el-popover{margin-left:-85px;width:320px;border:1px solid #282729;z-index:2000!important}.custom-user-pop.el-popover .el-input input{border:none;padding-right:0}.custom-user-pop.el-popover .el-tree-node__expand-icon{position:absolute;right:0}.custom-user-pop.el-popover .popper__arrow{display:none}", ""]);
// Exports
module.exports = exports;
